import { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Modal } from 'reactstrap'
import { changeTab_action, toggleSettingsModal_action, getActiveSubscription_action, getCompany_action } from 'store/actions'
import { SettingItems, SettingsTabs, ShowList, TabContent } from './styles'
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg'
import { ReactComponent as ImportExportIcon } from 'assets/images/icons/import-export.svg'

import ProfileSetting from './components/ProfileSetting'
import ExtensionSettings from './components/ExtensionSettings'
import GeneralSetting from './components/GeneralSetting'
import MembersSetting from './components/MembersSetting'
import TeamsSetting from './components/TeamsSetting'
import ImportContent from './components/ImportContent'
import NotificationSettings from './components/NotificationSettings'
import IntegrationsSettings from './components/Integrations'
import BillingSettings from './components/BillingSettings'
import { getCompanyByUUID_api } from 'store/apis'
import { BsBell, BsBoundingBoxCircles, BsCreditCard, BsGear, BsListUl, BsPeople, BsPersonCircle, BsPuzzle } from 'react-icons/bs'
import { FiChrome } from 'react-icons/fi'
import { handleApiError } from 'utils/helpers'
import ChangePasswordModal from './components/ChangePasswordModal'
import { history } from 'store/store'

export const SettingsModal = (props) => {
  const {
    company,
    settings: { showSettingsModal, active_tab }
  } = props
  const [_active_company, set_active_company] = useState({})
  const [is_loading, set_is_loading] = useState(true)
  const [_company, set_company] = useState({ members: [] })
  const [hideTemplateList, set_hideTemplateList] = useState(false)
  const [showChangePassword, set_showChangePassword] = useState(false)

  const get_company = useCallback(async () => {
    try {
      set_is_loading(true)
      const result = await getCompanyByUUID_api(company.company.uuid)
      set_company(result)
    } catch (error) {
      handleApiError(error)
    }
    set_is_loading(false)
  }, [company.company.uuid])

  useEffect(() => {
    if (!_active_company.id && company.company.id) {
      set_active_company(company.company)
      get_company()
    }
  }, [company.company, _active_company, get_company])

  const changeTab = (e, tab) => {
    e.preventDefault()
    props.changeTab(tab)
    set_hideTemplateList(true)
  }

  const closeModal = () => {
    history.replace({ search: '' })
    props.toggleSettingsModal(false)
  }

  return (
    <>
      <Modal centered fade={false} zIndex={props.fullScreenStatus && '3000000000'} isOpen={showSettingsModal} className='modal-lg modal-xl' toggle={() => closeModal()}>
        {hideTemplateList && (
          <ShowList
            href='/'
            onClick={(e) => {
              e.preventDefault()
              set_hideTemplateList(false)
            }}>
            <BsListUl /> Menu
          </ShowList>
        )}
        <div className='d-flex justify-content-between'>
          <TabContent className={hideTemplateList ? 'hideTemplateList' : ''}>
            {active_tab === 'profile' && <ProfileSetting set_showChangePassword={set_showChangePassword} />}
            {active_tab === 'chrome_extension' && <ExtensionSettings />}
            {active_tab === 'general' && <GeneralSetting />}
            {active_tab === 'notifications' && <NotificationSettings />}
            {active_tab === 'import' && <ImportContent />}
            {active_tab === 'team_members' && <MembersSetting subscription={props.subscription} is_loading={is_loading} />}
            {active_tab === 'user_groups' && <TeamsSetting company={_company} is_loading={is_loading} get_company={get_company} />}
            {active_tab === 'integrations' && <IntegrationsSettings />}
            {active_tab === 'billing' && (
              <BillingSettings get_company={get_company} toggleSettingsModal={props.toggleSettingsModal} changeTab={props.changeTab} company={_company} is_company_loading={is_loading} />
            )}
          </TabContent>

          <SettingsTabs className={`${hideTemplateList ? 'hideTemplateList' : ''}`}>
            <a
              href='/'
              className='modal-close'
              onClick={(e) => {
                e.preventDefault()
                closeModal()
              }}>
              <CloseIcon />
            </a>

            <div className='title'>Personal Settings</div>
            <SettingItems boldActive={true}>
              <li className={active_tab === 'profile' ? 'active' : ''}>
                <a href='/' onClick={(e) => changeTab(e, 'profile')}>
                  <BsPersonCircle />
                  <span>Profile</span>
                </a>
              </li>
              <li className={active_tab === 'notifications' ? 'active' : ''}>
                <a href='/' onClick={(e) => changeTab(e, 'notifications')}>
                  <BsBell />
                  <span>Notifications</span>
                </a>
              </li>
              <li className={active_tab === 'chrome_extension' ? 'active' : ''}>
                <a href='/' onClick={(e) => changeTab(e, 'chrome_extension')}>
                  <FiChrome />
                  <span>Chrome Extension</span>
                </a>
              </li>
              <li className={active_tab === 'import' ? 'active' : ''}>
                <a href='/' onClick={(e) => changeTab(e, 'import')}>
                  <ImportExportIcon />
                  <span>Import/Export Content</span>
                </a>
              </li>
            </SettingItems>
            <div className='title'>Company Settings</div>
            <SettingItems boldActive={true}>
              <li className={active_tab === 'general' ? 'active' : ''}>
                <a href='/' onClick={(e) => changeTab(e, 'general')}>
                  <BsGear />
                  <span>General</span>
                </a>
              </li>
              <li className={active_tab === 'team_members' ? 'active' : ''}>
                <a href='/' onClick={(e) => changeTab(e, 'team_members')}>
                  <BsPeople />
                  <span>Members</span>
                </a>
              </li>
              <li className={active_tab === 'user_groups' ? 'active' : ''}>
                <a href='/' onClick={(e) => changeTab(e, 'user_groups')}>
                  <BsBoundingBoxCircles />
                  <span>User Groups</span>
                </a>
              </li>
              <li className={active_tab === 'billing' ? 'active' : ''}>
                <a href='/' onClick={(e) => changeTab(e, 'billing')}>
                  <BsCreditCard />
                  <span>Billing</span>
                </a>
              </li>
              <li className={active_tab === 'integrations' ? 'active' : ''}>
                <a href='/' onClick={(e) => changeTab(e, 'integrations')}>
                  <BsPuzzle />
                  <span>Integrations</span>
                </a>
              </li>
            </SettingItems>
          </SettingsTabs>
        </div>
      </Modal>
      {showChangePassword && <ChangePasswordModal set_showChangePassword={set_showChangePassword} />}
    </>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  settings: state.settings,
  company: state.company,
  subscription: state.subscription.subscription,
  fullScreenStatus: state.contents.isFullScreen
})

const mapDispatchToProps = (dispatch) => ({
  toggleSettingsModal: (status) => dispatch(toggleSettingsModal_action(status)),
  changeTab: (value) => dispatch(changeTab_action(value)),
  getCompany: () => dispatch(getCompany_action()),
  getActiveSubscription: () => dispatch(getActiveSubscription_action())
})

export default connect(mapStateToProps, mapDispatchToProps)(SettingsModal)
